import React, { useEffect, useState } from 'react';
import api from '../api/axios';
import { useParams } from 'react-router-dom';
import { useState as useStateHook, useEffect as useEffectHook } from 'react';

const useIsMobile = () => {
  const [isMobile, setIsMobile] = React.useState(window.innerWidth < 768);
  React.useEffect(() => {
    const h = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', h);
    return () => window.removeEventListener('resize', h);
  }, []);
  return isMobile;
};

const StarRating = ({ value, onChange, disabled }) => {
  const [hover, setHover] = useState(0);
  const labels = ['', 'Çok Kötü', 'Kötü', 'İdare Eder', 'İyi', 'Çok İyi'];
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'flex-start', gap: 6 }}>
      <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
        {[1,2,3,4,5].map(star => (
          <button key={star} type="button"
            onClick={() => !disabled && onChange(star)}
            onMouseEnter={() => !disabled && setHover(star)}
            onMouseLeave={() => setHover(0)}
            style={{ background: 'none', border: 'none', cursor: disabled ? 'default' : 'pointer', padding: 2, transition: 'transform 0.15s' }}
            onMouseDown={e => e.currentTarget.style.transform = 'scale(0.9)'}
            onMouseUp={e => e.currentTarget.style.transform = 'scale(1)'}>
            <svg width="36" height="36" viewBox="0 0 24 24" fill={(hover || value) >= star ? '#6366f1' : '#e2e8f0'} style={{ transition: 'fill 0.15s' }}>
              <polygon points="12,2 15.09,8.26 22,9.27 17,14.14 18.18,21.02 12,17.77 5.82,21.02 7,14.14 2,9.27 8.91,8.26" stroke={(hover || value) >= star ? '#6366f1' : '#cbd5e1'} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </button>
        ))}
        {(hover || value) > 0 && (
          <span style={{ fontSize: 13, color: '#6366f1', fontWeight: 600, marginLeft: 4 }}>
            {labels[hover || value]}
          </span>
        )}
      </div>
    </div>
  );
};

export default function Survey() {
  const isMobile = useIsMobile();
  const { slug } = useParams();
  const [survey, setSurvey] = useState(null);
  const [answers, setAnswers] = useState({});
  const [name, setName] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [errors, setErrors] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/surveys/' + slug).then(r => { setSurvey(r.data); setLoading(false); }).catch(() => setLoading(false));
  }, []);

  const sections = survey ? [...new Set(survey.questions.map(q => q.section))] : [];

  const validate = () => {
    const errs = {};
    survey.questions.forEach(q => {
      if (q.is_required && !answers[q.id]) errs[q.id] = true;
    });
    setErrors(errs);
    return Object.keys(errs).length === 0;
  };

  const submit = async () => {
    if (!validate()) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
    setSubmitting(true);
    try {
      await api.post('/surveys/' + slug + '/submit', { answers, respondent_name: name || 'Anonim' });
      setSubmitted(true);
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } catch(e) { alert('Hata oluştu, lütfen tekrar deneyin.'); }
    setSubmitting(false);
  };

  if (loading) return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f5f7fa, #c3cfe2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ color: '#6366f1', fontSize: 16, fontWeight: 600 }}>Yükleniyor...</div>
    </div>
  );

  if (!survey) return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f5f7fa, #c3cfe2)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ background: 'white', borderRadius: 20, padding: 40, textAlign: 'center' }}>
        <div style={{ fontSize: 48, marginBottom: 16 }}>😕</div>
        <div style={{ fontWeight: 700, fontSize: 18, color: '#111' }}>Anket bulunamadı</div>
      </div>
    </div>
  );

  if (submitted) return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f5f7fa, #c3cfe2)', display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div style={{ background: 'white', borderRadius: 24, padding: '48px 40px', maxWidth: 500, width: '100%', textAlign: 'center', boxShadow: '0 20px 50px rgba(0,0,0,0.08)' }}>
        <div style={{ fontSize: 64, marginBottom: 20 }}>🎉</div>
        <h2 style={{ fontWeight: 800, fontSize: 24, color: '#111', marginBottom: 12 }}>Teşekkürler!</h2>
        <p style={{ color: '#6b7280', fontSize: 15, lineHeight: 1.7 }}>
          Değerlendirmeniz başarıyla alındı. Görüşleriniz bizim için çok değerli.
        </p>
        <div style={{ marginTop: 28, padding: '16px 20px', background: '#f0f3ff', borderRadius: 12 }}>
          <p style={{ color: '#6366f1', fontSize: 13, fontWeight: 600, margin: 0 }}>Petlas Eğitim ve Akademi</p>
        </div>
      </div>
    </div>
  );

  const hasErrors = Object.keys(errors).length > 0;

  return (
    <div style={{ minHeight: '100vh', background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', padding: isMobile ? '16px 12px' : '40px 20px', fontFamily: "'Poppins', sans-serif" }}>
      <div style={{ maxWidth: 700, margin: '0 auto' }}>

        {/* Header Kutusu */}
        <div style={{ background: 'white', borderRadius: 20, padding: isMobile ? '24px 20px' : '36px 32px', marginBottom: 16, boxShadow: '0 20px 50px rgba(0,0,0,0.08)', textAlign: 'center' }}>
          <img src="https://ik.ikpetlas.com/wp-content/uploads/2024/11/petlas_logo_zeminsiz-kucuk.webp" alt="Petlas Logo"
            style={{ maxWidth: isMobile ? 120 : 160, height: 'auto', marginBottom: isMobile ? 14 : 20 }}
            onError={e => e.target.style.display='none'} />
          <h1 style={{ fontWeight: 800, fontSize: isMobile ? 18 : 24, color: '#0f172a', marginBottom: 8, letterSpacing: -0.5 }}>{survey.title}</h1>
          <div style={{ width: 60, height: 3, background: '#6366f1', borderRadius: 2, margin: '0 auto 16px' }} />
          <p style={{ color: '#64748b', fontSize: 14, lineHeight: 1.7, margin: 0 }}>{survey.description}</p>
        </div>

        {hasErrors && (
          <div style={{ background: '#fef2f2', border: '1px solid #fca5a5', borderRadius: 12, padding: '12px 20px', marginBottom: 16, color: '#dc2626', fontSize: 13, fontWeight: 600 }}>
            ⚠️ Lütfen zorunlu soruları yanıtlayınız.
          </div>
        )}

        {/* İsim alanı */}
        <div style={{ background: 'white', borderRadius: 20, padding: '24px 28px', marginBottom: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.06)' }}>
          <label style={{ display: 'block', fontWeight: 600, fontSize: 14, color: '#1e293b', marginBottom: 10 }}>
            Adınız Soyadınız <span style={{ color: '#94a3b8', fontWeight: 400 }}>(isteğe bağlı)</span>
          </label>
          <input value={name} onChange={e => setName(e.target.value)} placeholder="Adınızı giriniz..."
            style={{ width: '100%', padding: '12px 16px', border: '1.5px solid #e2e8f0', borderRadius: 12, fontSize: 14, outline: 'none', boxSizing: 'border-box', fontFamily: 'inherit' }} />
        </div>

        {/* Sorular - bölüm bölüm */}
        {sections.map(section => (
          <div key={section} style={{ background: 'white', borderRadius: 20, padding: '28px 28px', marginBottom: 16, boxShadow: '0 4px 20px rgba(0,0,0,0.06)' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 24 }}>
              <div style={{ width: 4, height: 28, background: 'linear-gradient(180deg, #6366f1, #4f46e5)', borderRadius: 4 }} />
              <h2 style={{ fontWeight: 700, fontSize: 16, color: '#0f172a', margin: 0 }}>{section}</h2>
            </div>

            {survey.questions.filter(q => q.section === section).map((q, qi) => (
              <div key={q.id} style={{ marginBottom: qi < survey.questions.filter(x => x.section === section).length - 1 ? 28 : 0 }}>
                <label style={{ display: 'block', fontWeight: 600, fontSize: 14, color: errors[q.id] ? '#dc2626' : '#1e293b', marginBottom: 12, lineHeight: 1.5 }}>
                  {q.label}
                  {q.is_required && <span style={{ color: '#dc2626', marginLeft: 4 }}>*</span>}
                </label>

                {q.question_type === 'rating' ? (
                  <div style={{ padding: '14px 16px', background: errors[q.id] ? '#fef2f2' : '#f8faff', borderRadius: 12, border: `1.5px solid ${errors[q.id] ? '#fca5a5' : '#e2e8f0'}` }}>
                    <StarRating value={answers[q.id] || 0} onChange={val => {
                      setAnswers(prev => ({...prev, [q.id]: val}));
                      setErrors(prev => { const n = {...prev}; delete n[q.id]; return n; });
                    }} />
                  </div>
                ) : (
                  <textarea value={answers[q.id] || ''} onChange={e => setAnswers(prev => ({...prev, [q.id]: e.target.value}))}
                    placeholder="Görüşlerinizi yazınız..." rows={4}
                    style={{ width: '100%', padding: '12px 16px', border: '1.5px solid #e2e8f0', borderRadius: 12, fontSize: 14, outline: 'none', resize: 'vertical', boxSizing: 'border-box', fontFamily: 'inherit', lineHeight: 1.6 }} />
                )}
              </div>
            ))}
          </div>
        ))}

        {/* Gönder Butonu */}
        <div style={{ textAlign: 'center', paddingBottom: 40 }}>
          <button onClick={submit} disabled={submitting}
            style={{ background: submitting ? '#94a3b8' : 'linear-gradient(135deg, #6366f1, #4f46e5)', color: 'white', border: 'none', borderRadius: 50, padding: isMobile ? '14px 40px' : '16px 60px', fontSize: isMobile ? 15 : 16, fontWeight: 700, cursor: submitting ? 'not-allowed' : 'pointer', boxShadow: '0 8px 24px rgba(99,102,241,0.3)', transition: 'all 0.2s', fontFamily: 'inherit', letterSpacing: 0.3, width: isMobile ? '100%' : 'auto' }}>
            {submitting ? 'Gönderiliyor...' : 'Anketi Gönder'}
          </button>
          <p style={{ color: '#94a3b8', fontSize: 12, marginTop: 12 }}>* ile işaretli alanlar zorunludur</p>
        </div>
      </div>
    </div>
  );
}
